module.exports = __webpack_public_path__ + "static/media/ms.672d771e.svg";